import stl from "./SingleTrendCard.module.css";
import useHelpers from "@hooks/useHelpers";

const SingleTrendCard = ({ trend, isEager }) => {
  const {createUrl} = useHelpers();

  return (
    <>
      <a
        className={stl.STC_Container}
        href={createUrl(`/trend/${trend?.perma_link}`)}
      >
        <img
          loading={isEager ? "eager" : "lazy"}
          src={trend?.list_img}
          alt={trend?.h1_tag}
          width={370}
          height={278}
        />
        <div className={stl.contentContainer}>
          <div className={stl.tagsContainer}>
            {trend?.makes &&
              trend?.makes?.map((item, idx) => {
                return (
                  <div key={idx} className={stl.tag}>
                    {item}
                  </div>
                );
              })}
            {trend?.models?.map((item, idx) => {
              return (
                <div key={idx} className={stl.tag}>
                  {item}
                </div>
              );
            })}
          </div>
          <h2>{trend?.h1_tag}</h2>
        </div>
      </a>
    </>
  );
};

export default SingleTrendCard;
